import React from 'react';
import cn from 'classnames';

import {useAccordion} from 'brandComponents/Accordion/AccordionContext';

import {IAccordionHeaderProps} from './IAccordionHeader';

// eslint-disable-next-line no-restricted-imports
import './AccordionHeader.scss';

const AccordionHeader = ({children, classNames, dataIds}: IAccordionHeaderProps) => {
	const {handleListOpen} = useAccordion();

	return (
		<div
			className={cn('accordion__heading', classNames)}
			onClick={handleListOpen}
			{...dataIds}
		>
			{children}
		</div>
	);
};

export default AccordionHeader;
